<script>
  import { onMount, onDestroy } from "svelte";
  import { slide } from "svelte/transition";
  import { once } from '../svelte_utils';
  let { message, logo } = $props();
  let show = $state(false);

  onMount(() => {
    show = true;
    let x = document.getElementById("notificationHeightFix");
    if (x) {
      x.classList.remove("h-0", "overflow-hidden");
      x.classList.add("lg:h-[90px]");
    }
  });

  onDestroy(() => {
    let x = document.getElementById("notificationHeightFix");
    if (x) {
      x.classList.add("h-0", "overflow-hidden");
      x.classList.remove("lg:h-[90px]");
    }
  });
</script>

{#if show}
  <div class="alert" transition:slide>
    <div class="alert__content">
      <div class="alert__logo">
        {@html logo}
      </div>

      <div class="alert__message">
        {@html message}
      </div>
      <button
        class="alert__close"
        aria-label="Close this dialog window"
        onclick={once(() => {
          let x = document.getElementById("notificationHeightFix");
          fetch("/api/banner/disable");
          if (x) {
            x.classList.remove("lg:h-[90px]");
            x.classList.add("h-0", "overflow-hidden");
          }
          setTimeout(() => {
            show = false;
          }, 300);
        })}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          role="presentation"
        >
          <path
            d="M10 20A10 10 0 0 1 6.108.786a10 10 0 0 1 7.785 18.428A9.937 9.937 0 0 1 10 20Zm0-8.3 2.321 2.321a1.2 1.2 0 1 0 1.7-1.7L11.7 10l2.321-2.321a1.2 1.2 0 1 0-1.7-1.7L10 8.3 7.678 5.982a1.2 1.2 0 0 0-1.7 1.7L8.3 10l-2.319 2.322a1.2 1.2 0 1 0 1.7 1.7L10 11.7Z"
            fill="#1c6586"
          />
        </svg>
      </button>
    </div>
  </div>
{/if}

<style>
  .alert {
    display: flex;
    flex-basis: auto;
    justify-content: center;
    background-color: #f3ede8;
    min-height: 90px;
    max-width: 100%;
    width: 100vw;
    margin-bottom: 0;
  }
  .alert__content {
    display: flex;
    flex-basis: auto;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: nowrap;
    width: 100%;
    padding: 1rem 1rem 3rem 1rem;
  }
  .alert__message {
    order: 3;
  }
  .alert__message :global(p) {
    margin: 0;
  }
  .alert__message :global(:first-child) {
    margin: 0 0 2rem 0;
  }

  .alert__close {
    cursor: pointer;
    margin-left: auto;
    order: 1;
  }

  .alert__logo {
    height: 26px;
    width: 179px;
    order: 2;
    margin: 0 0 2rem 0;
  }

  @media only screen and (min-width: 600px) {
    .alert__content {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      max-width: 1200px;
      padding: 1rem;
    }

    .alert__message {
      order: 2;
    }
    .alert__message :global(p) {
      margin: 0;
    }
    .alert__message :global(:first-child) {
      margin: 0 0 3px 0;
    }

    .alert__close {
      cursor: pointer;

      margin-left: auto;
      order: 3;
    }

    .alert__logo {
      height: 26px;
      width: 179px;
      margin-bottom: 0;
      margin: 0 0.6rem;
      order: 1;
    }
  }
</style>
